import { FC, SVGProps } from 'react'

export const IconX: FC<SVGProps<SVGSVGElement>> = props => (
  <svg fill="none" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="m12 4-8 8M4 4l8 8"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.33}
    />
  </svg>
)
